import { motion } from "framer-motion";

import ShareButtons from "../../../utility/ShareButtons";
import FAQAccordion from "../../../utility/FAQAccordion";

import QuickNavigation from "../../../utility/serviceTemplateutility/QuickNavigation";
import WhyUs from "../../../utility/serviceTemplateutility/WhyUs";
import CardDesign from "../../../utility/serviceTemplateutility/CardDesign";
import ListDesign from "../../../utility/serviceTemplateutility/ListDesign";
import MultiStepForm from "../../../utility/serviceTemplateutility/MultiStepForm";
import { useGlobalData } from "../../../contextApi/globalContextData";
import { useLanguage } from "../../../contextApi/languageContext";
import { useCart } from "../../../contextApi/cartContext";
import { foodintolernece } from "../../../text-files/labtest/foodintolerence.ts";
import OurTeam from "../../homepage/OurTeam.jsx";
import Testimonials from "../../homepage/Testimonials.jsx";
const FoodIntolerence = () => {
  const serviceUrl = window.location.href;
  const { sectionsData } = useGlobalData();
  const { language } = useLanguage();
  const { addToCart } = useCart();
  const content = foodintolernece[language];
  const shared = foodintolernece.shared;

  const faqData = [
    {
      question:
        "What is the difference between food intolerance and food allergy?",
      answer:
        "A food allergy triggers an immediate immune response, often causing more severe symptoms, while food intolerance affects digestion and generally results in milder symptoms over time.",
    },
    {
      question: "Can a food intolerance test diagnose all food-related issues?",
      answer:
        "A food intolerance test specifically identifies foods that your body cannot digest well but does not diagnose food allergies or other gastrointestinal conditions like celiac disease.",
    },
    {
      question: "How long does it take to get the results?",
      answer:
        "Typically, results are available within one to two weeks, depending on the method used.",
    },
    {
      question:
        "Will cutting out certain foods improve my symptoms immediately?",
      answer:
        "Some individuals experience relief shortly after eliminating problem foods, while others may notice gradual improvements over a few weeks.",
    },
  ];
  const preparationSteps = [
    { heading: "Preparation" },
    {
      para: "Preparing for a food intolerance test is straightforward and involves a few simple steps to ensure accurate results. Follow these guidelines before your test",
    },
    {
      title: "Maintain a normal diet",
      description:
        "In the days leading up to the test, continue eating your usual diet so that the results accurately reflect your body’s current response to foods.",
      icon: "fas fa-utensils",
    },
    {
      title: "Avoid certain medications",
      description:
        "Some medications can interfere with test results. Consult with your healthcare provider to see if you need to avoid any medicines before the test.",
      icon: "fas fa-pills",
    },
    {
      title: "Stay hydrated",
      description:
        "Drinking water before the test helps ensure that your body is in a normal state and assists with the blood sample process.",
      icon: "fas fa-tint",
    },
  ];
  const benefits = [
    { heading: "Benefits" },
    {
      para: "A food intolerance test can significantly improve your quality of life by identifying which foods cause discomfort or other health problems. This test offers several benefits, including",
    },
    {
      title: "1. Customized dietary guidance",
      description:
        "The results enable you to tailor your diet to eliminate problematic foods, reducing digestive discomfort.",
      icon: "fas fa-utensils", // Icon for food/diet
    },
    {
      title: "2. Enhanced digestion",
      description:
        "By avoiding foods that irritate your system, you can experience smoother digestion and fewer gastrointestinal issues like bloating, gas, or indigestion.",
      icon: "fas fa-drumstick-bite", // Icon for digestion or stomach
    },
    {
      title: "3. Improved energy levels",
      description:
        "Food intolerances can contribute to fatigue. Adjusting your diet can help you feel more energized throughout the day.",
      icon: "fas fa-bolt", // Icon for energy
    },
    {
      title: "4. Relief from chronic symptoms",
      description:
        "Food intolerances can manifest as headaches, skin issues, or joint pain. Identifying and eliminating these foods can alleviate these persistent symptoms.",
      icon: "fas fa-heartbeat", // Icon for health/relief
    },
  ];

  const procedures = [
    { heading: "Procedure" },
    {
      para: "The food intolerance test involves several methods to detect sensitivities to different foods, commonly through blood tests, skin tests, or elimination diets. These methods can reveal specific foods that may be causing symptoms such as bloating, diarrhea, headaches, or fatigue.",
    },
    {
      title: "Initial Consultation",
      description:
        "Discuss symptoms, dietary habits, and health concerns with a physician.",
      icon: "fa-solid fa-user-doctor",
    },
    {
      title: "Lab Analysis",
      description:
        "The sample is analyzed for reactions to various food categories and additives.",
      icon: "fa-solid fa-flask",
    },
    {
      title: "Doctor’s Review",
      description:
        "Consultation to review results and develop a personalized diet plan based on the findings.",
      icon: "fa-solid fa-stethoscope",
    },
    {
      title: "Blood Sample Collection",
      description:
        "A simple blood test is conducted to measure IgG antibodies against specific foods.",
      icon: "fa-solid fa-tint",
    },
    {
      title: "Health Report",
      description:
        "A detailed report is provided, highlighting any intolerances or sensitivities.",
      icon: "fa-solid fa-file-alt",
    },
    {
      title: "Follow-Up Support",
      description:
        "Ongoing guidance for dietary adjustments and managing food intolerances.",
      icon: "fa-solid fa-headset",
    },
  ];

  return (
    <>
      <title>Food Intolerance Test -</title>
      <meta
        name="description"
        content="Uncover Hidden Food Intolerances for a Healthier You"
      />
      <meta
        name="robots"
        content="follow, index, max-snippet:-1, max-video-preview:-1, max-image-preview:large"
      />
      <link
        rel="canonical"
        href="https://elitebodyhome.com/services/food-intolerance-test/"
      />
      <meta property="og:locale" content="en_US" />
      <meta property="og:type" content="article" />
      <meta property="og:title" content="Food Intolerance Test -" />
      <meta
        property="og:description"
        content="Uncover Hidden Food Intolerances for a Healthier You"
      />
      <meta
        property="og:url"
        content="https://elitebodyhome.com/food-intolerance-test/"
      />
      <meta property="og:site_name" content="elitebodyhome.com" />
      <meta property="og:updated_time" content="2025-02-27T07:27:50+00:00" />
      <meta
        property="og:image"
        content="https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Food-Intolerance-Test-2.jpg"
      />
      <meta
        property="og:image:secure_url"
        content="https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Food-Intolerance-Test-2.jpg"
      />
      <meta property="og:image:width" content="1254" />
      <meta property="og:image:height" content="700" />
      <meta property="og:image:alt" content="Food Intolerance Test" />
      <meta property="og:image:type" content="image/jpeg" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Food Intolerance Test -" />
      <meta
        name="twitter:description"
        content="Uncover Hidden Food Intolerances for a Healthier You"
      />
      <meta
        name="twitter:image"
        content="https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Food-Intolerance-Test-2.jpg"
      />
      <div
        className="min-vh-100 font-sans text-dark  mb-5 mx-3"
        dir={language === "ar" ? "rtl" : "ltr"}
      >
        {/* Hero Image Section */}

        {language === "en" ? (
          <div className="container-fluid px-0 py-4">
            <div className="row justify-content-center">
              <div>
                <div
                  className="rounded-4 overflow-hidden shadow-sm"
                  style={{ border: "2px solid #c69933" }}
                >
                  <div className="row g-0 align-items-stretch">
                    {/* Image Column - Left Side */}
                    <div className="col-lg-6">
                      <img
                        loading="lazy"
                        decoding="async"
                        src={shared.images.main}
                        // src="https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/iv-large.jpg"
                        className="img-fluid w-100 h-100 object-fit-cover"
                        alt="food intolerence dubai"
                        style={{
                          minHeight: "400px",
                          maxHeight: "720px",
                        }}
                      />
                    </div>

                    {/* Content Column - Right Side */}
                    <div className="col-lg-6 d-flex align-items-center bg-white">
                      <div
                        className="p-4 p-md-5 w-100"
                        style={{ maxWidth: "600px", margin: "0 auto" }}
                      >
                        <h1
                          className="display-5 fw-bold mb-3"
                          style={{
                            color: "#c69933",
                          }}
                        >
                          Food Intolerance Test
                        </h1>
                        <p className="fs-5 text-secondary mb-4">
                          Uncover Hidden Food Intolerances for a Healthier You
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="container-fluid px-0 py-4">
            <div className="row justify-content-center">
              <div>
                <div
                  className="rounded-4 overflow-hidden shadow-sm"
                  style={{ border: "2px solid #c69933" }}
                >
                  <div className="row g-0 align-items-stretch">
                    {/* Image Column - Left Side */}
                    <div className="col-lg-6">
                      <img
                        loading="lazy"
                        decoding="async"
                        src={shared.images.main}
                        className="img-fluid w-100 h-100 object-fit-cover"
                        alt="food intolerence dubai"
                        style={{
                          minHeight: "400px",
                          maxHeight: "720px",
                        }}
                      />
                    </div>

                    {/* Content Column - Right Side */}
                    <div className="col-lg-6 d-flex align-items-center bg-white">
                      <div
                        className="p-4 p-md-5 w-100"
                        style={{ maxWidth: "600px", margin: "0 auto" }}
                      >
                        <h1
                          className="display-5 fw-bold mb-3"
                          style={{
                            color: "#c69933",
                          }}
                        >
                          اختبار عدم تحمل الطعام
                        </h1>
                        <p className="fs-5 text-secondary mb-4">
                          اكتشف حالات عدم تحمل الطعام المخفية من أجل صحة أفضل
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        <div className="d-flex gap-4  w-100 ">
          <div
            className=" rounded-4 p-1 bg-white flex-grow-1 "
            style={{
              width: "65%",
              border: "2px solid #c69933",
            }}
          >
            {/* Main Content Column */}

            {/* Breadcrumbs */}
            <nav aria-label="breadcrumb" className="p-2">
              <ol className="breadcrumb">
                {content.breadcrumbs.map((item, index) => (
                  <li
                    key={index}
                    className={`breadcrumb-item ${
                      index === content.breadcrumbs.length - 1 ? "active" : ""
                    }`}
                    aria-current={
                      index === content.breadcrumbs.length - 1
                        ? "page"
                        : undefined
                    }
                  >
                    {index === content.breadcrumbs.length - 1 ? (
                      item
                    ) : (
                      <a href={index === 0 ? "/home" : "#"}>{item}</a>
                    )}
                  </li>
                ))}
              </ol>
            </nav>

            {/* Title Section */}
            <div className="text-center my-2">
              <motion.h1
                className="display-4 fw-bold"
                style={{ color: "#c69933" }}
              >
                {content.hero.title}
              </motion.h1>

              {content.hero.subtitle && (
                <motion.h2 className="fw-semibold mt-3">
                  {content.hero.subtitle}
                </motion.h2>
              )}

              {content.hero.description && (
                <motion.p className="lead mt-3">
                  {content.hero.description}
                </motion.p>
              )}
            </div>

            <QuickNavigation />

            {/* How It Works Section */}
            {content.howItWorks.title && (
              <motion.section className="my-5">
                <h2 className="h2 fw-bold mb-4 text-center">
                  {content.howItWorks.title}
                </h2>
                {content.howItWorks.description && (
                  <p className="text-muted text-center">
                    {content.howItWorks.description}
                  </p>
                )}
              </motion.section>
            )}

            {/* Introduction Image */}
            {shared.images.introductionImage && (
              <motion.div className="my-5">
                <div className="text-center">
                  <img
                    src={shared.images.introductionImage}
                    alt="fat freezing treatment dubai"
                    className="img-fluid rounded shadow"
                    style={{ maxHeight: "500px" }}
                    loading="lazy"
                    decoding="async"
                  />
                </div>
              </motion.div>
            )}

            {/* Process Section */}
            <section id="process" className="my-5">
              <CardDesign carditems={content.procedureSteps} />
            </section>

            {/* Benefits Section */}
            <section id="benefits" className="my-5">
              <ListDesign listitems={content.benefits} />
            </section>

            <section id="process" className="my-5">
              <ListDesign listitems={content.ingredients} />
            </section>

            {/* Eligibility Section */}
            <section id="eligibility" className="my-5">
              <CardDesign listitems={content.eligibility} />
            </section>

            {/* Preparation Section */}
            <section id="preparations" className="my-5">
              <ListDesign listitems={content.preparationTips} />
            </section>

            {/* Results Section */}
            <section id="results" className="my-5">
              <ListDesign listitems={content.results} />
            </section>

            {/* Before & After Section */}
            {/* {shared.images.beforeAfter &&
              shared.images.beforeAfter.length > 0 && (
                <motion.section
                  className="my-5"
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true }}
                >
                  <BeforeAfterCarousel
                    language={language}
                    images={shared.images.beforeAfter}
                  />
                </motion.section>
              )} */}
            {/* Aftercare Section */}
            <section className="my-5">
              <ListDesign listitems={content.aftercareTips} />
            </section>

            {/* Product Card */}
            {shared.images.main && (
              <motion.div
                className="my-5"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
              >
                <div
                  className="card border-0 shadow-lg rounded-4 overflow-hidden mx-auto"
                  style={{ maxWidth: "420px" }}
                >
                  <img
                    src={shared.images.main}
                    alt={content.meta.title}
                    className="card-img-top"
                    style={{ height: "280px", objectFit: "cover" }}
                  />
                  <div className="card-body text-center px-4 py-4">
                    <h5 className="card-title fw-bold text-uppercase text-dark mb-2">
                      {content.meta.title}
                    </h5>
                    <p className="card-text text-muted small">
                      {content.meta.description}
                    </p>
                    {/* <h6
                        className="text-success fw-bold mt-3"
                        style={{ fontSize: "1.1rem" }}
                      >
                        {language === "en" ? "Price" : "السعر"}: AED{" "}
                        {shared.product.price}
                      </h6> */}
                    <button
                      className="btn rounded-pill px-4 py-2 mt-3 text-white fw-bold"
                      style={{
                        background: "#c69933",
                        border: "2px solid #c69933",
                      }}
                      onClick={() =>
                        addToCart({
                          ...shared.product,
                          image: shared.images.main,
                        })
                      }
                    >
                      {language === "en" ? "Add to Cart" : "أضف إلى السلة"}
                    </button>
                  </div>
                </div>
              </motion.div>
            )}
            <WhyUs language={language} />
            <OurTeam data={sectionsData["Professional"]} />
            <Testimonials
              data={sectionsData["Success Stories"]}
              language={language}
            />
            <FAQAccordion faqData={content.faqData} />
            <ShareButtons url={serviceUrl} />
          </div>
          <MultiStepForm />
        </div>
      </div>
    </>
  );
};

export default FoodIntolerence;
